import Button from '@r1-frontend/ui-react/components/buttons/button';
import CustomScrollbar from '@r1-frontend/ui-react/components/CustomScrollbar';
import { Guide } from '@r1-frontend/ui-react/components/Guide';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { Drawer, Footer } from '~/src/components/Drawer';
import { setIsShowDetails } from '~/src/features/work-in-home-ab/components/Description/components/Credit/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/features/work-in-home-ab/components/Description/components/Credit/context/hooks';
import { useCreditGuide } from '~/src/features/work-in-home-ab/components/Description/components/Credit/hooks/useCreditGuide';

import * as ST from './styled';

interface IProps {
    onOrder: () => void,
}

const CreditDetails = ({ onOrder }: IProps): JSX.Element => {
    const dispatch = useContextDispatch();
    const { isShow, selectedCreditCondition } = useContextSelector(state => ({
        isShow: state.isShowDetails,
        selectedCreditCondition: state.selectedCreditCondition,
    }));

    const guide = useCreditGuide(selectedCreditCondition);

    return (
        <Drawer isOpen={isShow} onClose={() => dispatch(setIsShowDetails(false))}>
            <CustomScrollbar customStyles={ST.ScrollbarCustomStyles}>
                <IndentContainer $desktop={[24, 32]} $mobile={[24]}>
                    <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={24}>
                        <TextWrapper $lastIndent={false}>
                            <H3 $withIndent={false}>Рассрочка от&nbsp;банка-партнёра</H3>
                            <Paragraph4 $color={COLORS.TextSecondary}>Пользуйтесь оборудованием сразу, а&nbsp;платите за&nbsp;него постепенно.<br/>
                                <a href={'https://www.uralfd.ru/about/'} rel='noreferrer'> Подробнее о&nbsp;банке</a>
                            </Paragraph4>
                        </TextWrapper>

                        <ListContainer $direction={'column'} $wrap={'nowrap'} $size={0}>
                            <Guide items={guide}/>
                        </ListContainer>
                    </FullWidthListContainer>
                </IndentContainer>
            </CustomScrollbar>
            <Footer>
                <Button size={'large'} bType={'action'} onClick={onOrder}>
                    Оформить рассрочку
                </Button>
            </Footer>
        </Drawer>
    );
};

export default CreditDetails;
